module.exports = __webpack_public_path__ + "static/media/unauthorized.959d6140.jpg";